import { render, staticRenderFns } from "./ForecastModalTypeButton.vue?vue&type=template&id=b048ad54"
import script from "./ForecastModalTypeButton.vue?vue&type=script&lang=ts"
export * from "./ForecastModalTypeButton.vue?vue&type=script&lang=ts"
import style0 from "./ForecastModalTypeButton.vue?vue&type=style&index=0&id=b048ad54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports